// extracted by mini-css-extract-plugin
export default {"answers":"CompleteAnswers_answers__ENXuk","answer":"CompleteAnswers_answer__IrEOX","pos":"CompleteAnswers_pos__ZERbJ"};